<template>
	<div>
		<p v-html="html"></p>
		<p>发起支付中,请稍后...</p>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				html: "",
				type:''
			};
		},
		mounted() {
			this.html = this.$route.params.context
			this.type = this.$route.params.type

			
		},
		updated() {
			if(this.type = 'alipay' && this.html != ''){
				// console.log(document.forms['alipay_submit'])
				document.forms['alipay_submit'].submit();
			}
		},
		methods: {

		}
	};
</script>
<style>

</style>